import React, { useMemo } from "react";
import { SpreadsheetGrid } from "@components/spreadsheet/SpreadsheetGrid";
import { SpreadsheetData } from "@components/spreadsheet/types";
import { Account } from "@common/types/domains/accounting/account";
import { ClassWithChildren } from "@helpers/class";
import {
    getJournalEntryLinesColumns,
    GRID_TEMPLATE_COLUMNS,
    GRID_TEMPLATE_COLUMNS_NO_CLASS,
} from "./views/journalEntryLinesSpreadsheetConfig";
import styles from "./HistoryJournalEntryDetails.module.scss";

const NEVER_EDITABLE = () => false;

interface JournalEntryLinesTableProps {
    lines: SpreadsheetData;
    accounts: Account[];
    counterpartiesMap: Map<string, string>;
    classesMap: Map<string, ClassWithChildren>;
    hasAnyClass: boolean;
}

export const JournalEntryLinesTable: React.FC<JournalEntryLinesTableProps> = ({
    lines,
    accounts,
    counterpartiesMap,
    classesMap,
    hasAnyClass,
}) => {
    const columns = useMemo(
        () =>
            getJournalEntryLinesColumns({
                accounts,
                counterpartiesMap,
                classesMap,
                hasAnyClass,
            }),
        [accounts, hasAnyClass, counterpartiesMap, classesMap],
    );

    return (
        <SpreadsheetGrid
            isCellEditable={NEVER_EDITABLE}
            className={styles.spreadsheet}
            stickyHeader
            showTotalsRow
            noOuterBorder
            minSpareRows={20}
            data={lines}
            columns={columns}
            gridTemplateColumns={
                hasAnyClass
                    ? GRID_TEMPLATE_COLUMNS
                    : GRID_TEMPLATE_COLUMNS_NO_CLASS
            }
            lightNotEditableCells
        />
    );
};
